// Everything imported here evaluates before the listener exists, so imports go deep past the @bindery/logging barrel (React, web-vitals) and never reach ./backend. ./earlyImportWall.test.ts enforces this.
import { appLogging } from "./appLogging";

export {
  MAX_EARLY_EVENTS,
  toError,
  type UnhandledErrorReporter,
  type UnhandledErrorSource,
} from "@bindery/logging/client/early-error-capture";

const { capture } = appLogging;

export const { reportUnhandledError, setUnhandledErrorReporter } = capture;

// Window guard keeps this importable from node (vitest, prerender).
if (typeof window !== "undefined") capture.install(window);
